import { Reducer } from 'redux';
import { ErrorsState, ErrorsAction, ShowErrorUpdateMessageAction } from './type';
import { showErrorPopupHandler, showErrorUpdateMessageStateHandler } from './handlers';
import { CLOSE_ERROR_POPUP, SHOW_ERROR_UPDATE_MESSAGE } from './constant';
import { ErrorCodes } from '../../dtos/KioskDtos.dtos';

export const initialState: ErrorsState = {
    showErrorPopup: false,
    currentErrorCode: ErrorCodes.None,
    returnToMainScreen: false
};

const reducer: Reducer<ErrorsState> = (state: ErrorsState = initialState, action: ErrorsAction) => {
    switch (action.type) {
        case CLOSE_ERROR_POPUP:
            return showErrorPopupHandler(state);

        case SHOW_ERROR_UPDATE_MESSAGE:
            return showErrorUpdateMessageStateHandler(state, action as ShowErrorUpdateMessageAction);

        default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/Errors/reducer.ts